export function initEliteExtraOrders() {
    var $eliteExtraElement = $('[data-elite-extra]');
    var $viewAsAccount = $('#vaa');

    if ($eliteExtraElement.length) {
        $.ajax({
            url:
                '/elite-extra/ajaxGetOrders' +
                ($viewAsAccount.length ? '?au=' + $viewAsAccount.val() : ''),
            type: 'get',
            dataType: 'json',
            success: function (response) {
                if (response.banner) {
                    $eliteExtraElement.replaceWith(response.banner);
                }

                if (response.modal) {
                    $('#main').append(response.modal);
                }
            },
            error: function () {
                $eliteExtraElement.remove();
                console.error('Failed to get orders from Elite Extra.');
            },
        });
    }
}
